export const buildMentionableUsers = (collaboratorsList, currentUser) => {
  const candidates = [];
  const owner = collaboratorsList?.budget_owner;
  if (owner?.id) {
    candidates.push({
      id: owner.id,
      name: owner.name || owner.email,
      email: owner.email,
      profileImage: owner.profile_image || '',
    });
  }

  (collaboratorsList?.registered_collaborators || []).forEach(collaborator => {
    if (!collaborator?.collaborator_user) return;
    candidates.push({
      id: collaborator.collaborator_user,
      name:
        collaborator.collaborator_name || collaborator.collaborator_user_email,
      email: collaborator.collaborator_user_email,
      profileImage: collaborator.collaborator_profile_image || '',
    });
  });

  const currentUserId = currentUser?.id?.toString();
  const currentUserEmail = String(currentUser?.email || '').toLowerCase();
  const uniqueUsers = new Map();
  candidates.forEach(candidate => {
    if (
      candidate.id?.toString() === currentUserId ||
      String(candidate.email || '').toLowerCase() === currentUserEmail
    ) {
      return;
    }
    uniqueUsers.set(candidate.id.toString(), candidate);
  });

  return Array.from(uniqueUsers.values()).sort((left, right) =>
    String(left.name || left.email).localeCompare(
      String(right.name || right.email)
    )
  );
};

export const getMentionToken = user =>
  `@${String(user?.name || user?.email || '').trim()}`;
